<template>
  <v-menu bottom left offset-y min-width="200px">
    <template v-slot:activator="{ on: menu }">
      <v-tooltip bottom>
        <template v-slot:activator="{ on: tooltip }">
          <v-btn icon v-on="{ ...tooltip, ...menu }">
            <v-icon>mdi-dots-vertical</v-icon>
          </v-btn>
        </template>
        <span>{{ $t('moreActions') }}</span>
      </v-tooltip>
    </template>

    <v-list dense>
      <v-list-item @click="openMergeDialog">
        <v-list-item-icon>
          <v-icon small>mdi-call-merge</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
           <v-list-item-title>{{ $t('contact.mergeTitle') }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-list-item @click="openDeleteDialog(contact)" :disabled="currentTenant !== 'cs'">
        <v-list-item-icon>
          <v-icon small>mdi-delete-outline</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
           <v-list-item-title>{{ $t('delete') }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-divider></v-divider>

      <v-subheader class="px-5">{{ $t('contact.changeLabels') }}</v-subheader>
      <v-list-item
        v-for="label of contactLabelsMapped"
        :key="label.id"
        @click.stop="toggleLabelSelected(label)"
      >
        <v-list-item-icon>
          <v-icon small>mdi-label-outline</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>{{ label.name }}</v-list-item-title>
        </v-list-item-content>
        <v-list-item-icon>
          <v-icon v-show="label.selected" color="primary">mdi-check</v-icon>
        </v-list-item-icon>
      </v-list-item>
    </v-list>
    <contact-merge-dialog
      :contact="contact"
      :dialog="mergeDialog"
      @close="onMergeDialogClose"
    ></contact-merge-dialog>
  </v-menu>
</template>


<script>
import eventBus from '@/eventBus'

import { mapGetters, mapActions } from 'vuex'

import ContactMergeDialog from './ContactMergeDialog'

import snackbarMixin from '@/mixins/snackbar.mixin'


export default {
  components: {
    ContactMergeDialog
  },


  mixins: [
    snackbarMixin
  ],


  props: {
    contact: Object
  },


  data () {
    return {
      createDialog: false,
      mergeDialog: false
    }
  },


  computed: {
    ...mapGetters('contactLabel', ['contactLabels']),
    ...mapGetters('tenant', ['currentTenant']),

    contactLabelsMapped () {
      return this.contactLabels.map((item) => {
        const selected = !!this.contact.labels.find(x => x === item.id)
        return {
          id: item.id,
          name: item.name,
          selected
        }
      })
    }
  },


  methods: {
    ...mapActions('contact', ['addLabelToContact', 'removeLabelFromContact', 'deleteContact']),

    async toggleLabelSelected (label) {
      try {
        this.showSnackbarProcessing()
        const payload = { contactId: this.contact.id, labelId: label.id }
        if (label.selected === true) {
          await this.removeLabelFromContact(payload)
        } else {
          await this.addLabelToContact(payload)
        }
        this.hideSnackbar()
      } catch (error) {
        this.showSnackbarError()
        this.$log.error(error)
      }
    },

    openDeleteDialog (contact) {
      eventBus.$emit('openDeleteDialog', contact)
    },

    openMergeDialog () {
      this.mergeDialog = true
    },

    onMergeDialogClose (merged) {
      this.mergeDialog = false
      if (merged) {
        this.$emit('merged')
      }
    }
  }
}
</script>
